// Native image drag hijacks mouse gestures (e.g. swipe actions, drag-scroll carousels) on desktop
export default defineNuxtPlugin(() => {
  document.addEventListener('dragstart', (event) => {
    if (event.target instanceof HTMLImageElement) event.preventDefault()
  })
})
